module.exports = __webpack_public_path__ + "media/images/introduction-826bf8adc3e923937a044f64d2b5a210.jpg";